export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/modelIconOrange.8065284e.svg","height":12,"width":26,"blurWidth":0,"blurHeight":0};